// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CampaignForm_wrapper__GYK3t"};